import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type StatusFooterLinkProps = ComponentProps<"a">

// Thin styling wrapper so every footer link reads identically and
// we have one place to tweak hover / focus affordance. Off-site
// links (placepoint.no / Console / Docs) are rendered with the
// same visual weight as the RSS link to keep the footer scannable.
function StatusFooterLink(props: Readonly<StatusFooterLinkProps>) {
  const { className, ...rest } = props
  return (
    <a
      className={cn(
        "text-muted-foreground underline-offset-4 transition-colors",
        "hover:text-primary hover:underline focus-visible:underline",
        className,
      )}
      {...rest}
    />
  )
}

export default StatusFooterLink
